export default "__VITE_ASSET__CoIH88iH__"